<template>
  <div class="planAlokasiChart" ref="chartDiv" style="width: 100%; height: 400px"></div>
</template>

<script>
import { create } from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
  XYChart,
  DateAxis,
  ValueAxis,
  ColumnSeries,
  LineSeries,
  Legend,
} from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import moment from "moment";
export default {
  data() {
    return {
      chart: null,
      trendlineSeries: null,
    };
  },
  name: "ColumnBarChart",
  watch: {
    data: function (newData, oldData) {
      if (newData !== oldData) {
        this.getData();
      }
    },
  },
  props: ["data"],
  methods: {
    getData() {
      this.chart.series.clear();

      let firstData = this.data[0];

      if (!firstData) return;

      let keys = Object.keys(firstData);
      if (keys.length === 1) {
        this.data = this.data.map((x) => {
          return {
            ...x,
            "N/A": 0,
          };
        });
        keys.push("N/A");
      }

      keys.forEach((curKeys, index) => {
        if (curKeys === "date") return;

        let series = this.chart.series.getIndex(index);
        if (!series) {
          series = this.chart.series.push(new LineSeries());
          series.strokeWidth = 5;
          series.tooltipText = `Serial Number {name} on {categoryX}: [bold]{valueY}[/]`;
        }

        series.dataFields.valueY = curKeys;
        series.dataFields.categoryX = "date";
        series.name = curKeys;
      });

      let length = this.chart.data.length;
      this.chart.addData(this.data && this.data.length > 0 ? this.data : [{ date: 0 }], length);
    },
  },
  mounted() {
    // Apply the animated theme for some basic chart animations
    am4core.useTheme(am4themes_animated);

    // Create the chart instance
    const chart = create(this.$refs.chartDiv, XYChart);

    // Create category axis
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "date";
    //   categoryAxis.title.text = 'Plants';
    categoryAxis.renderer.labels.template.fill = am4core.color("#383838");

    // Create value axis
    const valueAxis = chart.yAxes.push(new ValueAxis());
    valueAxis.title.text = "Activity";
    valueAxis.title.fontFill = am4core.color("#383838");
    valueAxis.title.fill = am4core.color("#383838");
    valueAxis.renderer.labels.template.fill = am4core.color("#383838");
    valueAxis.min = 0;

    // Set the visible maximum limit on the y-axis to 100
    // valueAxis.max = 1000;

    chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = categoryAxis;

    this.chart = chart;
    this.getData();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>
